import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PasoonVoiceIntro } from '../components/PasoonVoiceIntro';
import { IntroSection } from '../components/IntroSection';
import { AboutSection } from '../components/AboutSection';
import { CurrentIssue } from '../components/CurrentIssue';
import { PublishingCycle } from '../components/PublishingCycle';
import { ArchivePreview } from '../components/ArchivePreview';
import { SubscriptionSupport } from '../components/SubscriptionSupport';
import { Language } from '../App';
interface HomeProps {
  language: Language;
}
export function Home({
  language
}: HomeProps) {
  return <div data-id="element-556">
      <HeroSection language={language} data-id="element-557" />
      <PasoonVoiceIntro language={language} data-id="element-558" />
      <IntroSection language={language} data-id="element-559" />
      <AboutSection language={language} data-id="element-560" />
      <CurrentIssue language={language} data-id="element-561" />
      <PublishingCycle language={language} data-id="element-562" />
      <ArchivePreview language={language} data-id="element-563" />
      <SubscriptionSupport language={language} data-id="element-564" />
    </div>;
}